// extracted by mini-css-extract-plugin
module.exports = {"container":"MeepCardResume_container__3J0Yw","item":"MeepCardResume_item__3FaI1"};